function subscribe (listId, email, params = {}) {
  const config = Object.assign({}, params, {
    g: listId,
    email
  })

  const body = Object.keys(config).reduce((str, key) => {
    str.append(key, config[key])
    return str
  }, new URLSearchParams())

  return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
    method: 'POST',
    headers: {
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
    },
    body
  }).then(res => res.json())
}

// modal
if (document.querySelector(".js-modal")) {

  document.querySelector(".js-modal").addEventListener("keydown", function (event) {
    if (event.keyCode == 27) {
      event.preventDefault();
      document.body.classList.remove("modal--open");
      Cookies.set("modal", "closed");
    }
  })

  const form = document.querySelector('.js-modal-form')
  const success = document.querySelector('.js-modal-form-success')

  if (Cookies.get("modal") === undefined) {
    setTimeout(() => {
      document.body.classList.add("modal--open");

      setTimeout(function () {
        console.log(document.querySelector('.js-modal-email'))
        document.querySelector('.js-modal-email').focus()
      }, 150)
    }, 5000);
  }

  let close_triggers = document.querySelectorAll(".js-modal-close")
    
  for (const close_trigger of close_triggers) {
    close_trigger.addEventListener("click", () => {
      document.body.classList.remove("modal--open");
      Cookies.set("modal", "closed");
    });    
  }

  

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const listId = "TCw4x7";
    const email = form.querySelector('[name="contact[email]"]').value
    
    subscribe(listId, email).then(response => {

      if (response.data.is_subscribed) {
        alert('You are already subscribed!')   
      } else {
        form.style.display = 'none'
        success.style.display = 'block'
      }      

    });


  })

}


const listId = "JFDd6y";
const email = "email@email.com";

subscribe(listId, email, {
  $first_name: "Eric"
  // any optional traits
}).then(response => {});